import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IStoreSettings } from '../../../../../../../common/common-interfaces/store-settings';
import { IStoreSummaryData, IVendorCostSummary } from '../../../../../../../common/common-interfaces/store-statistics';
import { Api } from '../../../services/api';
import { Globals } from '../../../services/globals';
import moment from 'moment';
import { Utility } from 'src/app/services/utility';

@Component({
    selector: 'pictufy-overview',
    templateUrl: './pictufy-overview.component.html',
    styleUrls: ['./pictufy-overview.component.scss'],
    standalone: false
})
export class PictufyOverviewComponent {
  stores: IStoreSettings[];
  storeData: { [id: string]: any } = {};
  pictufyData: any;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility) {

  }

  async ngOnInit() {
    this.pictufyData = await this.api.admin().get<any>(`/pictufy-data`);
    await this.fetchStores();
  }


  async fetchStores() {
    this.stores = await this.api.admin().get<any>(`/stores`);
    this.stores = this.stores.filter(s => s.pictufySettings && s.pictufySettings.enabled);
    if (this.stores && this.stores.length) {
      for (let store of this.stores) {
        this.storeData[store._id] = await this.api.store(store).get<any>(`/pictufy-summary`);
      }
    }
  }

}
